import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { ValidatorForm, SelectValidator} from 'react-material-ui-form-validator';
import MenuItem from '@material-ui/core/MenuItem';
import SendIcon from '@material-ui/icons/Send';


import ParentDetails from './parent-details'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import ListItemText from '@material-ui/core/ListItemText';


 export default class App extends React.Component {





    render() {
        const { user } = this.props.state;
 const {handleChange,classes,direct_call,handleNext}=this.props

const {medium_list,admission_mode_list,scholarship_test_list }=this.props
let is_direct=true;
if(user.admission_mode_id && user.admission_mode_id!==3)
is_direct=false;
let validators_list_1=[],validators_list_1_msg=[];
if(!is_direct){
validators_list_1=['required'];
validators_list_1_msg=['this field is required']
}





if(direct_call)
return(
  <>
    <ParentDetails {...this.props} />
  <List disablePadding>
{medium_list.length>1 &&
  <ListItem className={classes.listItem} >
    <ListItemText  >
<Typography variant="subtitle2">Medium</Typography>
    </ListItemText>
    <Typography variant="body2">
    {medium_list.map(({id,name},i)=>{
  if(id===user.medium_id)
      return   name
    })}
    </Typography>
  </ListItem>
}

{admission_mode_list.length>1 &&
  <ListItem className={classes.listItem} >
    <ListItemText  >
<Typography variant="subtitle2">Admission Mode</Typography>
    </ListItemText>
    <Typography variant="body2">
    {admission_mode_list.map(({id,name},i)=>{
if(id===user.admission_mode_id)
      return    name
    })}

    </Typography>
  </ListItem>
}


{!is_direct  &&
  <ListItem className={classes.listItem} >
    <ListItemText  >
<Typography variant="subtitle2">R-NET Date</Typography>
    </ListItemText>
    <Typography variant="body2">
    {scholarship_test_list.map(({id,name},i)=>{
  if(id===user.scholarship_test_id)
      return   name
    })}

    </Typography>
  </ListItem>
}
  </List>
  </>
)

        return (
          <>
          <ParentDetails {...this.props} />
            <ValidatorForm
                onSubmit={handleNext}
            >
{medium_list.length>1 &&
  <>
                <SelectValidator
                  fullWidth
                    label="Choose Medium"
                    onChange={ handleChange}
                    name="medium_id"
                    validators={['required']}
                    errorMessages={['this field is required']}
                    value={user.medium_id}
                >
                {medium_list.map(({id,name},i)=>{

                  return   <MenuItem key={id} value={id}>{name}</MenuItem>
                })}


                </SelectValidator>
                 <br/>
                 </>

}


{admission_mode_list.length>1 &&
  <>
                <SelectValidator
fullWidth
                    label="Choose Admission Mode"
                    onChange={ handleChange}
                    name="admission_mode_id"
                    validators={['required']}
                    errorMessages={['this field is required']}
                    value={user.admission_mode_id}
                >
                {admission_mode_list.map(({id,name},i)=>{

                  return   <MenuItem key={id} value={id}>{name}</MenuItem>
                })}


                </SelectValidator>
                <br/>
                </>

               }

{!is_direct &&
  <>

                                <SelectValidator
                                  fullWidth
                                    label="Choose R-NET Date"
                                    onChange={ handleChange}
                                    name="scholarship_test_id"
                                    validators={validators_list_1}
                                    errorMessages={validators_list_1_msg}
                                    value={user.scholarship_test_id}
                                >
                                {scholarship_test_list.map(({id,name},i)=>{

                                  return   <MenuItem key={id} value={id}>{name}</MenuItem>
                                })}


                                </SelectValidator>
                                <br/>

</>
}



{!direct_call &&
  <div className={classes.buttons}>
<Button type="submit"  className={classes.button}   className={classes.button}   variant="contained" color="secondary"  endIcon={<SendIcon/>}>
      NEXT

    </Button>
    </div>
  }


            </ValidatorForm>


            </>
        );
    }
 }
